import script from "./MenuDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuDashboard.vue?vue&type=script&setup=true&lang=js"

import "./MenuDashboard.vue?vue&type=style&index=0&id=256c5b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256c5b12"]])

export default __exports__